<template>
  <div class="school-user-seeing" @click="moreVisible = false">
    <div
      v-if="campusrosterStuData"
      class="silder-contain slider-admissionCue slider-top-see"
    >
      <div class="slider-top clearFloat">
        <p class="h3 slider-title pull-left">查看学员信息</p>
        <div
          class="pull-right h1 btn-close font-gray"
          @click="hideUserSliderBox"
        >
          <i class="el-icon-close"></i>
        </div>
        <el-button
          v-if="isRoottrack || isyhavetrackedit"
          type="primary"
          class="pull-right"
          @click="onFllowSubmit(followForm)"
          >{{ $t("Common.btn_submit") }}</el-button
        >
        <!--<el-button
          v-if="iscanEdit && tabEdit"
          type="primary"
          class="pull-right"
          @click="Clickedit()"
        >{{$t('Common.btn_edit')}}</el-button>
        company_ismajor 0是免费版 1是普通版 2是专业版
        <div class="btn-binding pull-right" v-if="!isHome && companyIsmajor=='2'">
          <div class="biding-more">
            <el-button type="warning" @click.stop="handmoreVisible()">
              {{$t('User.see_btn_more')}}
              <i class="el-icon-caret-bottom"></i>
            </el-button>
          </div>
          <ul v-show="moreVisible" class="biding-list text-1">
            <li @click="studentBinding()">{{$t('User.see_btn_bind')}}</li>
          </ul>
        </div>-->
      </div>
      <div class="slider-person-info text-1 clearFloat">
        <div class="person" style="width: 50px; vertical-align: top">
          <div class="person-img pull-left">
            <img
              :src="
                campusrosterStuData.student.student_img ||
                (campusrosterStuData.student.student_sex == '女'
                  ? require('@/assets/images/default-img-women.png')
                  : require('@/assets/images/default-img-man.png'))
              "
            />
          </div>
        </div>
        <div class="myinfo">
          <div class="user-infor">
            {{ campusrosterStuData.student.student_cnname }}
            <img
              class="ml10"
              v-if="campusrosterStuData.student.student_sex == '男'"
              src="@/assets/images/icon/icon-person-men.png"
              alt=""
            />
            <img
              class="ml10"
              v-else
              src="@/assets/images/icon/icon-person-women.png"
              alt=""
            />
          </div>
          <div class="el-info-row mt10">
            <!-- <p class="el-col">
              <label>{{ $t("User.label_text1") }}</label>
              {{ campusrosterStuData.student.student_cnname }}
            </p> -->
            <p class="el-col mb5">
              <label>{{ $t("User.label_text5") }}</label>
              {{ campusrosterStuData.student.student_birthday }}
            </p>
            <p class="el-col mb5 flex-al">
              <label>意向星级：</label>
              <el-rate
                :value="campusrosterStuData.student.student_intention_level"
                disabled
                :icon-classes="['crm-likes', 'crm-likes', 'crm-likes']"
                void-icon-class="crm-like"
                disabled-void-icon-class="crm-like"
                :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
              ></el-rate>
            </p>
            <p class="el-col" v-if="studentType == 0">
              <label>账户余额：</label>
              <el-tooltip class="item" effect="light" placement="bottom">
                <span style="color: #20a8d8">{{
                  campusrosterStuData.student.student_balance_all
                }}</span>
                <div slot="content">
                  可退金额：{{ campusrosterStuData.student.student_balance
                  }}<br />不可退金额：{{
                    campusrosterStuData.student.student_withholdbalance
                  }}
                </div>
              </el-tooltip>
            </p>
          </div>
          <div class="el-info-row">
            <p class="el-col mb5">
              <label>{{ $t("User.label_text4") }}</label>
              {{ campusrosterStuData.student.parenter_mobile }}
            </p>
            <p class="el-col mb5">
              <label>最近跟进时间：</label>
              {{ campusrosterStuData.student.last_tracktime }}
            </p>
            <p class="el-col" v-if="studentType == 0">
              <label>欠费金额：</label>
              {{ campusrosterStuData.student.order_paymentprice }}
            </p>
          </div>
          <div class="el-info-row" v-if="studentType == 0">
            <p class="el-col">
              <label>结转金额：</label>
              {{ campusrosterStuData.student.student_forwardprice }}
            </p>
          </div>

          <div class="markup-container" v-if="!true">
            <el-button
              class="mb20"
              v-if="!stuInfoData.showAddMarkup"
              @click="stuInfoData.showAddMarkup = true"
              type="primary"
              size="small"
              >添加标签</el-button
            >
            <div class="markup-add" v-if="stuInfoData.showAddMarkup">
              <div class="markup-header">
                <p>
                  添加标签
                  <span>(最多可添加三个标签哦)</span>
                </p>
                <div class="markup-add__btns">
                  <el-button type="warning" size="small" @click="resetMarkup"
                    >取消</el-button
                  >
                  <el-button type="primary" size="small">保存</el-button>
                </div>
              </div>
              <div class="markup-content">
                <el-input
                  style="width: 300px"
                  class="mr10"
                  size="small"
                  placeholder="请输入标签内容(不超过二十个字)"
                  v-model.trim="stuInfoData.markup"
                ></el-input>
                <el-button @click="addMarkup" type="primary" size="small"
                  >确定</el-button
                >
              </div>
              <div class="markup-add__content">
                <div
                  class="markup-content__row"
                  v-for="(item, index) in stuInfoData.markupList"
                  :key="index"
                >
                  {{ item.txt }}
                  <span
                    @click="removeMarkup(index)"
                    class="el-icon-error"
                  ></span>
                </div>
              </div>
            </div>
          </div>

          <div class="tag-list">
            <span
              v-for="(item, index) in campusrosterStuData.student
                .student_crmtag"
              :key="index"
              class="tagItem"
            >
              {{ item }}
            </span>
            <span
              class="addTagBtn ml10"
              @click="addTagVisable = true"
              style="position: absolute; right: 50px"
              >添加标签</span
            >
          </div>

          <div class="myinfo-summary mt20">
            <span>
              跟进总次数：
              <em>{{ campusrosterStuData.student.track_allnum }}</em>
            </span>
            <span>
              普通回访：
              <em>{{ campusrosterStuData.student.track_followmodenum }}</em>
            </span>
            <template v-if="studentType == 1">
              <span>
                柜询：
                <em>{{ campusrosterStuData.student.invite_num }}</em>
              </span>
            </template>
            <span>
              试听：
              <em>{{ campusrosterStuData.student.audition_num }}</em>
            </span>
          </div>
        </div>
      </div>

      <el-tabs v-model="activeName" @tab-click="handleSliderClick">
        <el-tab-pane :label="$t('User.tab_pane1')" name="first">
          <div class="slider-cont text-1">
            <!-- <el-form ref="form" :model="form" label-width="100px"> -->
            <p class="form-small-title h3">{{ $t("User.s_title12") }}</p>
            <div class="BaseInfo">
              <p class="form-info-cont">
                <label>中文名：</label>
                <span>{{ campusrosterStuData.student.student_cnname }}</span>
              </p>
              <p class="form-info-cont">
                <label>英文名：</label>
                <span>{{ campusrosterStuData.student.student_enname }}</span>
              </p>
              <p class="form-info-cont">
                <label>编号：</label>
                <span>{{ campusrosterStuData.student.student_branch }}</span>
              </p>
              <p class="form-info-cont">
                <label>性别：</label>
                <span>{{ campusrosterStuData.student.student_sex }}</span>
              </p>
              <p class="form-info-cont">
                <label>{{ $t("User.label_card") }}</label>
                <span>{{ campusrosterStuData.student.student_idcard }}</span>
              </p>
              <p class="form-info-cont">
                <label>{{ $t("User.label_text18_4") }}</label>
                <span>{{ campusrosterStuData.student.nearschool_name }}</span>
              </p>
              <p class="form-info-cont">
                <label>来源小区</label>
                <span>{{ campusrosterStuData.student.client_community || "--" }}</span>
              </p>
            </div>
            <p class="form-small-title h3">{{ $t("User.s_title3") }}</p>
            <div class="BaseInfo">
              <div
                v-for="(item, index) in campusrosterStuData.family"
                :key="index"
                class="family-info"
              >
                <div class="family-row">
                  <p class="form-info-cont">
                    <span class="s1">{{ item.family_relation }}</span>
                    <span class="s2">{{ item.parenter_cnname }}</span>
                  </p>
                  <p class="form-info-cont">
                    <span class="s1">手机号</span>
                    <span class="s2">{{ item.parenter_mobile }}</span>
                  </p>
                  <em class="main-connect" v-if="item.family_isdefault == 1"
                    >主要联系人</em
                  >
                </div>
              </div>
            </div>
            <p class="form-small-title h3">{{ $t("User.s_title6") }}</p>
            <div class="BaseInfo">
              <p class="form-info-cont">
                <label>{{ $t("User.label_text16") }}</label>
                <span>{{ campusrosterStuData.client_remark }}</span>
              </p>
            </div>
            <!-- <el-form-item>
            <el-button type="primary" @click="onSubmit">确认</el-button>
            <el-button @click="hideSliderBox()">取消</el-button>
            </el-form-item>-->
            <!-- </el-form> -->
          </div>
        </el-tab-pane>
        <el-tab-pane label="课程" name="zero">
          <div class="slider-cont text-1">
            <div class="flex-wrap pr20">
              <div class="flex-al mb10 mr10">
                <div class="select-box flex-al">
                  <el-select
                    style="width: 130px"
                    filterable
                    clearable
                    size="small"
                    placeholder="选择班组"
                    v-model="campusCourseFliterData.coursetype_id"
                    @change="getCrmStuCourseList"
                  >
                    <el-option
                      v-for="(
                        item, index
                      ) in campusCourseFliterData.coursetypeList"
                      :key="index"
                      :label="`${item.coursetype_cnname}(${item.coursetype_branch})`"
                      :value="item.coursetype_id"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div v-if="studentType == 0" class="flex-al mb10 mr10">
                <div class="select-box flex-al">
                  <el-select
                    style="width: 150px"
                    filterable
                    clearable
                    size="small"
                    placeholder="选择在班状态"
                    v-model="campusCourseFliterData.study_isreading"
                    @change="getCrmStuCourseList"
                  >
                    <el-option
                      v-for="(item, index) in studyIsReadingList"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="flex-al Inquire-box mb10">
                <div class="ipt-box">
                  <el-input
                    clearable
                    placeholder="课程别名称、编号"
                    class="input-cont family-phone"
                    size="small"
                    v-model="campusCourseFliterData.keyword"
                    @clear="getCrmStuCourseList"
                  ></el-input>
                  <el-button
                    @click="getCrmStuCourseList"
                    type="primary"
                    class="btn-inquire btn-inquire2"
                    >{{ $t("Admissioncue.ap") }}</el-button
                  >
                </div>
              </div>
            </div>
            <div class="slider-tryRecord">
              <tipsTable
                :list="campusCourseFliterData.campusCourseList"
                :options="Classoptions"
                :columns="campusCourseFliterData.campusCourseColumns"
                :operates="ClassOperates"
              ></tipsTable>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="班级列表" name="five">
          <div class="slider-cont text-1">
            <div class="flex-wrap pr20">
              <div class="flex-al mb10 mr10">
                <div class="select-box flex-al">
                  <el-select
                    style="width: 130px"
                    filterable
                    clearable
                    size="small"
                    placeholder="请选择班组"
                    v-model="campusClassFliterData.coursetype_id"
                    @change="getCrmStuClassApi"
                  >
                    <el-option
                      v-for="(
                        item, index
                      ) in campusClassFliterData.coursetypeList"
                      :key="index"
                      :label="`${item.coursetype_cnname}(${item.coursetype_branch})`"
                      :value="item.coursetype_id"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="flex-al mb10 mr10">
                <div class="select-box flex-al">
                  <el-select
                    style="width: 130px"
                    filterable
                    clearable
                    size="small"
                    placeholder="请选择班种"
                    v-model="campusClassFliterData.coursecat_id"
                    @change="getCrmStuClassApi"
                  >
                    <el-option
                      v-for="(
                        item, index
                      ) in campusClassFliterData.coursecatList"
                      :key="index"
                      :label="`${item.coursecat_cnname}(${item.coursecat_branch})`"
                      :value="item.coursecat_id"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div v-if="studentType == 0" class="flex-al mb10 mr10">
                <div class="select-box flex-al">
                  <el-select
                    style="width: 140px"
                    clearable
                    filterable
                    size="small"
                    placeholder="请选择在班状态"
                    v-model="campusClassFliterData.study_isreading"
                    @change="getCrmStuClassApi"
                  >
                    <el-option
                      v-for="(item, index) in studyIsReadingList"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="flex-al Inquire-box mb10">
                <div class="ipt-box">
                  <el-input
                    clearable
                    placeholder="班级名称、别名"
                    class="input-cont family-phone"
                    size="small"
                    v-model="campusClassFliterData.keyword"
                    @clear="getCrmStuClassApi"
                  ></el-input>
                  <el-button
                    @click="getCrmStuClassApi"
                    type="primary"
                    class="btn-inquire btn-inquire2"
                    >{{ $t("Admissioncue.ap") }}</el-button
                  >
                </div>
              </div>
            </div>
            <div class="slider-tryRecord">
              <tipsTable
                :list="campusClassFliterData.campusClassList"
                :options="Classoptions"
                :columns="campusClassFliterData.campusClassColumns"
                :operates="ClassOperates"
              ></tipsTable>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="跟踪记录" name="second">
          <div class="slider-cont text-1">
            <div class="slider-trackRecord">
              <div class="record-info">
                <p class="form-small-title h3">{{ $t("User.s_title7") }}</p>
                <div
                  class="track-record"
                  v-for="(items, index) in recordData"
                  :key="index"
                >
                  <p class="track-time">{{ items.track_createtime }}</p>
                  <div class="track-racord__content">
                    <div class="track-status__header flex-all">
                      <div class="track-status">
                        <span v-if="items.track_followmode_name">{{
                          items.track_followmode_name
                        }}</span>
                        <!-- <span v-if="items.track_linktype">{{
                          items.track_linktype
                        }}</span> -->
                      </div>
                      <span class="flex-al" v-if="items.track_validinc_name">
                        <em class="dot"></em>
                        {{ items.track_validinc_name }}
                      </span>
                    </div>
                    <el-row>
                      <el-col :span="3">
                        <div class="grid-content bg-purple grid-content-img">
                          <img
                            :src="
                              items.marketer_img ||
                              (items.staffer_sex == '女'
                                ? photoImgWomen
                                : photoImgmen)
                            "
                          />
                        </div>
                      </el-col>
                      <el-col :span="20">
                        <div class="grid-content bg-purple-light text-1">
                          <p
                            class="pt5 pb10 clearFloat"
                            style="font-size: 15px; font-weight: bold"
                          >
                            {{ items.marketer_name }} {{ items.staffer_enname }}
                          </p>
                          <p>沟通类型：{{ items.track_linktype }}</p>
                          <p>
                            {{ $t("User.follow_label2")
                            }}{{
                              items.track_linktype != "取消跟踪" &&
                              items.track_linktype != "主管分配" &&
                              items.track_linktype != "自主跟进"
                                ? items.object_name
                                : "--"
                            }}
                          </p>
                          <p v-if="studentType == 0">
                            跟进班组：{{
                              items.track_linktype != "取消跟踪" &&
                              items.track_linktype != "主管分配" &&
                              items.track_linktype != "自主跟进"
                                ? items.coursetype_cnname
                                : "--"
                            }}
                          </p>
                          <p class="flex-al">
                            意向星级：
                            <el-rate
                              :value="Number(items.track_intention_level)"
                              disabled
                              :icon-classes="[
                                'crm-likes',
                                'crm-likes',
                                'crm-likes',
                              ]"
                              void-icon-class="crm-like"
                              disabled-void-icon-class="crm-like"
                              :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
                            ></el-rate>
                          </p>
                          <p v-if="items.track_followmode == '2'">
                            {{ $t("User.tryDate")
                            }}{{
                              items.track_linktype != "取消跟踪" &&
                              items.track_linktype != "主管分配" &&
                              items.track_linktype != "自主跟进"
                                ? items.track_visitingtime
                                : "--"
                            }}
                          </p>
                          <p v-if="items.track_followmode == '2'">
                            {{ $t("User.tryClass") }}{{ items.class_cnname }}
                          </p>
                          <p v-if="items.track_followmode == '1'">
                            {{ $t("User.guiDate")
                            }}{{ items.track_visitingtime }}
                          </p>
                          <p>
                            {{ $t("User.nextFollowDate")
                            }}{{ items.track_followuptime || "--" }}
                          </p>
                          <div class="flex-all">
                            <p>
                              {{ $t("User.followSchool") }}
                              {{ items.school_cnname }}
                            </p>
                            <p
                              v-if="items.track_isreading == '1'"
                              class="text-3 mb10"
                            >
                              {{ items.level_marketer_name }}
                              <span class="font-gray"
                                >{{ $t("User.label_text20")
                                }}{{ items.track_readtime
                                }}{{ $t("User.btn_text4") }}</span
                              >
                            </p>
                          </div>
                          <!-- 沟通内容 -->
                          <div class="communite-cont mb20">
                            <p>
                              {{ $t("User.communiteContent")
                              }}{{ items.track_note }}
                            </p>
                            <div
                              v-if="
                                postbe_crmlevel == '1' &&
                                items.track_isactive == '1'
                              "
                              class="btns"
                            >
                              <el-button
                                v-if="items.track_isreading == '0'"
                                type="warning"
                                @click="handRead(items, index)"
                                >{{ $t("User.btn_text4") }}</el-button
                              >
                              <el-button
                                v-else
                                type="warning"
                                disabled
                                class="btn-disabled"
                                >{{ $t("User.btn_text5") }}</el-button
                              >
                              <el-button
                                type="primary"
                                v-if="!items.isClickReply"
                                :disabled="items.replay_id > 0"
                                :class="{ 'btn-disabled': items.replay_id > 0 }"
                                @click="handReply(items, index)"
                                >{{ $t("User.btn_text6") }}</el-button
                              >
                            </div>
                          </div>
                          <!-- 回复内容 -->
                          <!-- 回复弹框 -->
                          <div
                            v-if="postbe_crmlevel == '1' && items.isClickReply"
                            class="communite-replay mb20"
                          >
                            <div class="img mt20 mb10">
                              <img
                                v-if="
                                  items.login_marketer_img != '' &&
                                  items.login_marketer_img != null
                                "
                                :src="items.login_marketer_img"
                              />
                              <img
                                v-else-if="items.login_marketer_sex == '女'"
                                :src="photoImgWomen"
                              />
                              <img v-else :src="photoImgmen" />
                            </div>
                            <div class="replay-cont">
                              <div class="replay-top mt20 mb10">
                                <span>
                                  {{ items.login_marketer_name }}
                                  <span class="font-gray ml5 mr5">{{
                                    $t("User.btn_text6")
                                  }}</span>
                                  {{ items.marketer_name }}
                                </span>
                                <div class="btns">
                                  <el-button
                                    type="primary"
                                    @click="
                                      levelReplayTrackAction(items, index)
                                    "
                                    >{{ $t("Common.btn_confirm") }}</el-button
                                  >
                                  <el-button
                                    plain
                                    @click="handCloseReply(items, index)"
                                    >{{ $t("Common.btn_cancel") }}</el-button
                                  >
                                </div>
                              </div>
                              <el-input
                                type="textarea"
                                rows="3"
                                style="width: 485px"
                                :placeholder="$t('User.replay_placeholder')"
                                v-model="items.replay_note"
                              ></el-input>
                            </div>
                          </div>
                          <!-- 回复列表 -->
                          <div
                            v-if="
                              items.replay_info && items.replay_info.length > 0
                            "
                            class="replay-list"
                          >
                            <div
                              v-for="(item1, index1) in items.replay_info"
                              :key="index1"
                              class="communite-replay"
                            >
                              <div class="img mt20 mb10">
                                <img
                                  v-if="
                                    item1.marketer_img != '' &&
                                    item1.marketer_img != null
                                  "
                                  :src="item1.marketer_img"
                                />
                                <img
                                  v-else-if="item1.staffer_sex == '女'"
                                  :src="photoImgWomen"
                                />
                                <img v-else :src="photoImgmen" />
                              </div>
                              <div class="replay-cont">
                                <div class="replay-top mt20 mb10">
                                  <span>
                                    {{ item1.marketer_name }}
                                    <span class="font-gray ml5 mr5">{{
                                      $t("User.btn_text6")
                                    }}</span>
                                    {{ items.marketer_name }}
                                  </span>
                                  <span class="font-gray">{{
                                    item1.replay_createtime
                                  }}</span>
                                </div>
                                <p>{{ item1.replay_note }}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <p v-if="recordDatalen == 0" class="no-data">
                  <i class="crm-wu"></i>
                  {{ $t("User.noFollowRecord") }}
                </p>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="柜询试听记录" v-if="studentType == 1" name="third">
          <div class="slider-cont text-1">
            <div class="slider-tryRecord">
              <p class="form-small-title h3">{{ $t("User.s_title8") }}</p>
              <tipsTable
                :list="tryRecordlist"
                :options="recordoptions"
                :columns="recordlistColumn"
                :operates="recordOperates"
              ></tipsTable>
              <p class="form-small-title h3">{{ $t("User.s_title9") }}</p>
              <tipsTable
                :list="tryClasslist"
                :options="Classoptions"
                :columns="ClasslistColumn"
                :operates="ClassOperates"
              ></tipsTable>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="试听记录" v-if="studentType == 0" name="autition">
          <div class="slider-cont text-1">
            <div class="slider-tryRecord">
              <p class="form-small-title h3">{{ $t("User.s_title9") }}</p>
              <tipsTable
                :list="tryClasslist"
                :options="Classoptions"
                :columns="ClasslistColumn"
                :operates="ClassOperates"
              ></tipsTable>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane
          v-if="
            (isRoot || isyhavetrack || bindRoot) &&
            UserInformation.client_tracestatus_status != '-1' &&
            UserInformation.client_tracestatus_status != '-2' &&
            UserInformation.client_tracestatus_status != '4'
          "
          :label="$t('User.tab_pane4')"
          name="fourth"
        >
          <div class="slider-cont text-1">
            <div class="slider-followUp">
              <el-form
                ref="followForm"
                :rules="followRules"
                :model="followForm"
                label-width="140px"
              >
                <p class="form-small-title h3">{{ $t("User.s_title10") }}</p>
                <el-form-item
                  prop="track_followmode"
                  :label="$t('User.follow_label5')"
                >
                  <el-radio-group
                    v-model="followForm.track_followmode"
                    @change="sourceFilter"
                    class="type-follow"
                  >
                    <el-radio label="0">
                      {{ $t("User.follow_options2[2]") }}
                    </el-radio>
                    <template v-if="studentType != 0">
                      <el-radio label="1">
                        {{ $t("User.follow_options2[0]") }}
                      </el-radio>
                    </template>
                    <el-radio label="2">
                      {{ $t("User.follow_options2[1]") }}
                    </el-radio>

                    <el-radio label="4">转介绍跟踪</el-radio>
                    <!--<el-radio label="-1">
                      {{ $t("User.follow_options2[3]") }}
                    </el-radio>
                    <el-radio label="-2">
                      {{ $t("User.follow_options2[4]") }}
                    </el-radio>-->
                  </el-radio-group>
                </el-form-item>

                <el-form-item
                  prop="track_linktype"
                  :label="$t('User.follow_label1')"
                >
                  <el-select
                    filterable
                    v-model="followForm.track_linktype"
                    style="width: 340px"
                    :placeholder="$t('User.follow_placeholder1')"
                  >
                    <el-option
                      v-for="items in CommodeData"
                      :key="items.commode_id"
                      :label="items.commode_name"
                      :value="items.commode_name"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  prop="object_code"
                  :label="$t('User.follow_label2')"
                >
                  <el-select
                    filterable
                    v-model="followForm.object_code"
                    style="width: 340px"
                    :placeholder="$t('User.follow_placeholder2')"
                  >
                    <el-option
                      v-for="items in ObjectData"
                      :key="items.object_code"
                      :label="items.object_name"
                      :value="items.object_code"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  prop="track_validinc"
                  :label="$t('User.follow_label3')"
                >
                  <el-radio-group v-model="followForm.track_validinc">
                    <el-radio label="1">{{
                      $t("User.follow_options1[0]")
                    }}</el-radio>
                    <el-radio label="2">{{
                      $t("User.follow_options1[1]")
                    }}</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  prop="track_intention_level"
                  :label="$t('User.follow_label4')"
                  v-if="followForm.track_followmode != '4'"
                >
                  <el-rate
                    v-model="followForm.track_intention_level"
                    show-text
                    class="rate-startLevel"
                    :texts="intentionLevelList"
                    :icon-classes="['crm-likes', 'crm-likes', 'crm-likes']"
                    void-icon-class="crm-like"
                    :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
                  ></el-rate>
                </el-form-item>

                <el-form-item
                  v-if="
                    (followForm.track_followmode == '1' ||
                      followForm.track_followmode === '0' ||
                      followForm.track_followmode == '-1') &&
                    campusrosterStuData.student.company_istrackcoursetype == 1
                  "
                  prop="coursetype_branch"
                  label="跟进班组："
                  :rules="[
                    {
                      required:
                        campusrosterStuData.student
                          .company_ismusttrackcoursetype == 1,
                      message: '请选择跟进班组',
                      trigger: ['change', 'blur'],
                    },
                  ]"
                >
                  <el-select
                    placeholder="请选择跟进班组"
                    filterable
                    clearable
                    style="width: 340px"
                    v-model="followForm.coursetype_branch"
                    @change="filterCourseCat"
                  >
                    <el-option
                      v-for="(item, index) in courstTypeList"
                      :label="`${item.coursetype_cnname}(${item.coursetype_branch})`"
                      :value="item.coursetype_id"
                      :key="`${Math.random()}${index}`"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  v-if="
                    (followForm.track_followmode == '1' ||
                      followForm.track_followmode === '0' ||
                      followForm.track_followmode == '-1') &&
                    campusrosterStuData.student.company_istrackcoursetype == 1
                  "
                  prop="coursecat_id"
                  :label="$t('User.ag')"
                  :rules="[
                    {
                      required:
                        campusrosterStuData.student
                          .company_ismusttrackcoursetype == 1,
                      message: $t('User.ah'),
                      trigger: ['change', 'blur'],
                    },
                  ]"
                >
                  <el-select
                    :placeholder="$t('User.ah')"
                    filterable
                    clearable
                    style="width: 340px"
                    v-model="followForm.coursecat_id"
                  >
                    <el-option
                      v-for="(item, index) in courseCatList"
                      :key="index"
                      :label="`${item.coursecat_cnname}(${item.coursecat_branch})`"
                      :value="item.coursecat_id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item
                  v-if="followForm.track_followmode == '2'"
                  :label="$t('User.follow_label6')"
                  :rules="[
                    {
                      required:
                        campusrosterStuData.student
                          .company_ismusttrackcoursetype == 1,
                      message: $t('User.follow_placeholder6'),
                      trigger: ['change', 'blur'],
                    },
                  ]"
                  prop="audition_genre"
                >
                  <el-select
                    filterable
                    v-model="followForm.audition_genre"
                    style="width: 340px"
                    :placeholder="$t('User.follow_placeholder6')"
                    @change="ClickAudition()"
                  >
                    <el-option
                      v-for="(item, index) in auditionTypesList"
                      :key="index"
                      :label="item.name"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  v-if="
                    followForm.track_followmode == '1' ||
                    followForm.track_followmode == '2'
                  "
                  :label="$t('User.follow_label7')"
                  prop="receiver_name"
                >
                  <el-select
                    filterable
                    v-model="followForm.receiver_name"
                    style="width: 340px"
                    :placeholder="$t('User.follow_placeholder7')"
                  >
                    <el-option
                      v-for="items in ReceiverList"
                      :key="items.marketer_id"
                      :label="items.marketer_name"
                      :value="items.marketer_name"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  v-if="followForm.track_followmode == '1'"
                  :label="$t('User.follow_label8')"
                >
                  <el-select
                    filterable
                    v-model="followForm.invite_genre"
                    style="width: 340px"
                    :placeholder="$t('User.follow_placeholder8')"
                  >
                    <el-option
                      :label="item.genre_reason"
                      :value="item.genre_id"
                      v-for="(item, index) in inviteGenreList"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  v-if="followForm.track_followmode == '1'"
                  prop="invite_visittime"
                  :label="$t('User.follow_label9')"
                >
                  <el-date-picker
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :placeholder="$t('User.follow_placeholder9')"
                    v-model="followForm.invite_visittime"
                    style="width: 340px"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item
                  v-if="followForm.track_followmode == '2'"
                  prop="audition_visittime"
                  :label="$t('User.follow_label10')"
                >
                  <el-date-picker
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :placeholder="$t('User.follow_placeholder10')"
                    v-model="followForm.audition_visittime"
                    @change="ClickAuditiontime()"
                    style="width: 340px"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item
                  v-if="followForm.track_followmode == '2'"
                  :label="$t('User.follow_label11')"
                >
                  <!-- <el-form-item v-if="followForm.track_followmode=='2'" prop="class_id" label="试听班级："> -->
                  <el-input
                    type="text"
                    :disabled="followForm.audition_genre === ''"
                    style="width: 340px"
                    @focus="leaning()"
                    @click="leaning()"
                    :placeholder="$t('User.follow_placeholder11_1')"
                    v-model="className"
                  ></el-input>
                  <br />
                  <el-input
                    type="text"
                    :disabled="followForm.audition_genre === ''"
                    style="width: 340px; margin-top: 15px"
                    :placeholder="$t('User.follow_placeholder11_2')"
                    v-model="followForm.class_cnname"
                  ></el-input>
                  <el-input
                    type="hidden"
                    style="width: 0px"
                    @focus="leaning()"
                    @click="leaning()"
                    :placeholder="$t('User.follow_placeholder11_1')"
                    v-model="followForm.class_id"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  v-if="followForm.track_followmode == '3'"
                  :label="$t('User.follow_label12')"
                >
                  <el-date-picker
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :placeholder="$t('User.follow_placeholder12')"
                    v-model="followForm.audition_visittime"
                    style="width: 340px"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item
                  v-if="followForm.track_followmode == '-1'"
                  :label="$t('User.follow_label13')"
                >
                  <el-select
                    filterable
                    v-model="followForm.invite_genre"
                    style="width: 340px"
                    :placeholder="$t('User.follow_placeholder13')"
                  >
                    <el-option
                      :label="$t('User.follow_options5[0]')"
                      value="0"
                    ></el-option>
                    <el-option
                      :label="$t('User.follow_options5[1]')"
                      value="1"
                    ></el-option>
                    <el-option
                      :label="$t('User.follow_options5[2]')"
                      value="2"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  v-if="
                    followForm.track_followmode == 2 &&
                    campusrosterStuData.student.company_istrackcoursetype == 1
                  "
                  prop="coursetype_branch"
                  label="跟进班组："
                  :rules="[
                    {
                      required:
                        campusrosterStuData.student
                          .company_ismusttrackcoursetype == 1,
                      message: '请选择跟进班组',
                      trigger: ['change', 'blur'],
                    },
                  ]"
                >
                  <el-select
                    placeholder="请选择跟进班组"
                    filterable
                    clearable
                    style="width: 340px"
                    v-model="followForm.coursetype_branch"
                    :disabled="
                      (followForm.audition_genre == '1' && !!className) ||
                      followForm.audition_genre === ''
                    "
                    @change="filterCourseCat"
                  >
                    <el-option
                      v-for="(item, index) in courstTypeList"
                      :label="`${item.coursetype_cnname}(${item.coursetype_branch})`"
                      :value="item.coursetype_id"
                      :key="`${Math.random()}${index}`"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item
                  v-if="
                    followForm.track_followmode == 2 &&
                    campusrosterStuData.student.company_istrackcoursetype == 1
                  "
                  prop="coursecat_id"
                  :label="$t('User.ag')"
                  :rules="[
                    {
                      required:
                        campusrosterStuData.student
                          .company_ismusttrackcoursetype == 1,
                      message: $t('User.ah'),
                      trigger: ['change', 'blur'],
                    },
                  ]"
                >
                  <el-select
                    :placeholder="$t('User.ah')"
                    filterable
                    clearable
                    style="width: 340px"
                    v-model="followForm.coursecat_id"
                    :disabled="
                      (followForm.audition_genre == '1' && !!className) ||
                      followForm.audition_genre === ''
                    "
                  >
                    <el-option
                      v-for="(item, index) in courseCatList"
                      :key="index"
                      :label="`${item.coursecat_cnname}(${item.coursecat_branch})`"
                      :value="item.coursecat_id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item :label="$t('User.ai')">
                  <!-- TraceNoteData -->
                  <el-select
                    filterable
                    v-model="checkList"
                    style="width: 340px"
                    placeholder="请选择常用模板"
                    @change="handClickModel()"
                  >
                    <el-option
                      v-for="items in TraceNoteData"
                      :key="items.tracenote_code"
                      :label="items.tracenote_remk"
                      :value="items.tracenote_remk"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('User.aj')" prop="track_note">
                  <el-input
                    type="textarea"
                    style="width: 340px"
                    :placeholder="$t('User.follow_placeholder14_2')"
                    v-model="followForm.track_note"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  prop="track_followuptype"
                  :label="$t('User.follow_label15')"
                >
                  <el-select
                    filterable
                    v-model="followForm.track_followuptype"
                    style="width: 340px"
                    :placeholder="$t('User.follow_placeholder15')"
                  >
                    <el-option
                      :label="$t('User.follow_options6[0]')"
                      value="0"
                    ></el-option>
                    <el-option
                      :label="$t('User.follow_options6[1]')"
                      value="1"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  v-if="followForm.track_followuptype == '1'"
                  :label="$t('User.follow_label16')"
                  prop="track_followuptime"
                >
                  <el-date-picker
                    type="date"
                    :placeholder="$t('User.follow_placeholder16')"
                    value-format="yyyy-MM-dd"
                    v-model="followForm.track_followuptime"
                    style="width: 340px"
                    :picker-options="{
                      disabledDate: (time) =>
                        time.getTime() + 24 * 60 * 60 * 1000 <= Date.now(),
                    }"
                  ></el-date-picker>
                </el-form-item>
              </el-form>
              <p class="form-small-title h3">{{ $t("User.s_title11") }}</p>
              <div
                class="track-record"
                v-for="(items, index) in currentrecordData"
                :key="index"
              >
                <p class="track-time">{{ items.track_createtime }}</p>
                <div class="track-racord__content">
                  <div class="track-status__header flex-all">
                    <div class="track-status">
                      <span v-if="items.track_followmode_name">{{
                        items.track_followmode_name
                      }}</span>
                      <!-- <span v-if="items.track_linktype">{{
                        items.track_linktype
                      }}</span> -->
                    </div>
                    <span class="flex-al" v-if="items.track_validinc_name">
                      <em class="dot"></em>
                      {{ items.track_validinc_name }}
                    </span>
                  </div>
                  <el-row>
                    <el-col :span="3">
                      <div class="grid-content bg-purple grid-content-img">
                        <img
                          :src="
                            items.marketer_img ||
                            (items.staffer_sex == '女'
                              ? photoImgWomen
                              : photoImgmen)
                          "
                        />
                      </div>
                    </el-col>
                    <el-col :span="20">
                      <div class="grid-content bg-purple-light text-1">
                        <p
                          class="pt5 pb10 clearFloat"
                          style="font-size: 15px; font-weight: bold"
                        >
                          {{ items.marketer_name }} {{ items.staffer_enname }}
                        </p>
                        <p>沟通类型：{{ items.track_linktype }}</p>
                        <p>
                          {{ $t("User.follow_label2") }}{{ items.object_name }}
                        </p>
                        <p>跟进班组：{{ items.coursetype_cnname }}</p>
                        <p class="flex-al">
                          意向星级：
                          <el-rate
                            :value="Number(items.track_intention_level)"
                            disabled
                            :icon-classes="[
                              'crm-likes',
                              'crm-likes',
                              'crm-likes',
                            ]"
                            void-icon-class="crm-like"
                            disabled-void-icon-class="crm-like"
                            :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
                          ></el-rate>
                        </p>
                        <p v-if="items.track_followmode == '2'">
                          {{ $t("User.tryDate") }}{{ items.track_visitingtime }}
                        </p>
                        <p v-if="items.track_followmode == '2'">
                          {{ $t("User.tryClass") }}{{ items.class_cnname }}
                        </p>
                        <p v-if="items.track_followmode == '1'">
                          {{ $t("User.guiDate") }}{{ items.track_visitingtime }}
                        </p>
                        <p>
                          {{ $t("User.nextFollowDate")
                          }}{{ items.track_followuptime || "--" }}
                        </p>
                        <div class="flex-all">
                          <p>
                            {{ $t("User.followSchool") }}
                            {{ items.school_cnname }}
                          </p>
                          <p
                            v-if="items.track_isreading == '1'"
                            class="text-3 mb10"
                          >
                            {{ items.level_marketer_name }}
                            <span class="font-gray"
                              >{{ $t("User.label_text20")
                              }}{{ items.track_readtime
                              }}{{ $t("User.btn_text4") }}</span
                            >
                          </p>
                        </div>
                        <!-- 沟通内容 -->
                        <div class="communite-cont mb20">
                          <p>
                            {{ $t("User.communiteContent")
                            }}{{ items.track_note }}
                          </p>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
              <p v-if="recordDatalen == 0" class="no-data">
                <i class="crm-wu"></i>
                {{ $t("User.noFollowRecord2") }}
              </p>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 试听班级 -->
    <div>
      <!-- 跟班试听 中间-->
    </div>

    <!-- 添加标签的弹框 -->
    <addTapPop
      v-if="addTagVisable"
      :newclientTags="newclientTag"
      :clientId="clientId"
      :dialogVisable="addTagVisable"
      :defautLabelList="campusrosterStuData.student.student_crmtag"
      :labelType="studentType == 0 ? 1 : 2"
      @handleCloseTip="addTagVisable = false"
      @handCancel="addTagVisable = false"
      @handConfirm="handConfirm"
    ></addTapPop>
  </div>
</template>

<script>
import tipsTable from "../Table/tipsTable";
import addTapPop from "./addTapPop";
import storeUser from "./User.js";
export default {
  name: "userSeeing",
  props: [
    "showUserSliderBox",
    "customerId",
    "isRoot",
    "isTrack",
    "iscanEdit",
    "seeSliderTitle",
    "isForm",
    "isHome",
    "isshowfirst",
    "ClassMessage",
    "isnotBiding", //不可绑定学员
    // "recordoptions",
    // "recordlistColumn",
    // "recordOperates",
    // "tryClasslist",
    // "Classoptions",
    // "ClasslistColumn",
    // "ClassOperates",
    // "CommodeData",
    // "BindingInfor",
    // "TraceNoteData",
    // "currentrecordData",
    "campusrosterStuData",
    "sId",
    "sType",
    "studentType", // 学员类型， 0 在籍学员，1 流失学员
    "newclientTags",
    "fromCrmIndex",
  ],
  data() {
    return {
      inviteGenreList: [],
      addTagVisable: false, //添加标签
      newclientTag: [],
      clientId: "",

      auditionTypesList: [],
      courstTypeList: [], // 跟进班组列表
      courseCatList: [],
      // 在班状态
      studyIsReadingList: [
        {
          value: 1,
          label: "在读",
        },
        {
          value: 0,
          label: "不在读",
        },

        {
          value: -1,
          label: "已结束",
        },
      ],

      campusCourseFliterData: {
        campusCourseList: [],
        campusCourseColumns: [],
        coursetypeList: [],
        coursetype_id: "",
        study_isreading: "",
        keyword: "",
      },
      campusClassFliterData: {
        campusClassList: [],
        campusClassColumns: [],
        coursetypeList: [],
        coursetype_id: "",
        coursecatList: [],
        coursecat_id: "",
        study_isreading: "",
        keyword: "",
      },

      // 查看学员信息  添加标签
      stuInfoData: {
        showAddMarkup: false,
        markup: "",
        markupList: [],
      },
      // 跟进
      followForm: {
        client_id: "",
        track_linktype: "",
        track_validinc: "",
        track_intention_level: null,
        track_followuptype: "",
        track_followuptime: "",
        track_followmode: "0", //本次跟进模式0普通回访1柜询2试听3转正-1跟进无意向
        // track_note_temp: "", //沟通模板不需要传
        coursetype_branch: "",
        coursecat_id: "",
        coursetype_id: "",
        track_note: "",
        class_id: "",
        class_cnname: "",
        invite_genre: "", //邀约柜询类型 邀约类型 变量 0普通柜询1能力测试
        client_lapsedtype: "", //无意向类型 0已报异业1强烈抵触2其他
        object_code: "", //沟通对象
        audition_genre: "", //试听类型
        receiver_name: "", //接待人
      },
      intentionLevelList: [], //意向星级注释列表
      activeName: "first",
      isClickBand: false,
      fllow_id: "",
      className: "",
      num: null,
      //判断是否有数据
      recordDatalen: 0,
      BindingInforlen: "",
      moreVisible: false,
      isyhavetrack: false,
      isyhavetrackedit: false,
      isRoottrack: false,
      bindRoot: false, //绑定学员跟进
      clientLevelNum: null, //意向星级
      tabEdit: true, //tab切换编辑权限
      checkList: ["1", "柜询"],
      iconWommen: require("../../assets/images/icon/icon-person-women.png"),
      iconmen: require("../../assets/images/icon/icon-person-men.png"),
      photoImgWomen: require("../../assets/images/default-staff-women.png"), //默认女头像
      photoImgmen: require("../../assets/images/default-staff-men.png"), //默认男头像
      //获取数据
      UserInformation: [], //用户基本信息
      // 跟踪记录
      recordData: [],
      currentrecordData: [], //最近跟踪记录
      oneTrackInfo: {}, //单个跟踪记录信息
      //柜询记录
      recordcolumnWidth: ["150", "150", "250", "auto"],
      tryRecordlist: [],
      recordlistColumn: [],
      recordoptions: {
        mutiSelect: false, // 是否支持列表项选中功能
        highlightCurrentRow: true, // 是否支持当前行高亮显示
        errortip: "",
      },
      recordOperates: {
        width: 200,
        label: this.$t("Common.operatesLabel"),
        align: "center",
        fixed: "right",
        list: [],
      },
      //试听课程表格开始
      ClasscolumnWidth: ["auto", "150", "150", "150", "150", "150"],
      ClassId: "",
      CourseId: "",
      HourId: "",
      tryClasslist: [],
      ClasslistColumn: [],
      Classoptions: {
        mutiSelect: false, // 是否支持列表项选中功能
        highlightCurrentRow: true, // 是否支持当前行高亮显示
        errortip: "",
      },
      ClassOperates: {
        width: 200,
        label: this.$t("Common.operatesLabel"),
        align: "center",
        fixed: "right",
        list: [],
      },
      CommodeData: [], //获取沟通类型
      ObjectData: [], //获取沟通对象
      ReceiverList: [], //接待人->获取有接待权限的接待人
      TraceNoteData: [], //沟通模板
      // 跟进校验规则
      followRules: {
        track_followmode: [
          {
            required: true,
            message: "请选择本次跟进类型",
          },
        ],
        track_linktype: [
          {
            required: true,
            message: "请选择沟通类型",
          },
        ],
        object_code: [
          {
            required: true,
            message: "请选择沟通对象",
          },
        ],
        track_validinc: [
          {
            required: true,
            message: "请选择沟通效果",
          },
        ],
        track_intention_level: [
          {
            required: true,
            message: "请选择沟通级别",
          },
        ],
        receiver_name: [
          {
            required: true,
            message: this.$t("User.follow_rule1"),
            trigger: "blur",
          },
        ],
        class_id: [
          {
            required: true,
            message: this.$t("User.follow_rule2"),
            trigger: "change,blur",
          },
        ],
        invite_visittime: [
          {
            required: true,
            message: this.$t("User.follow_rule3"),
            trigger: "change",
          },
        ],
        audition_visittime: [
          {
            required: true,
            message: this.$t("User.follow_rule4"),
            trigger: "change",
          },
        ],
        track_note: [
          {
            required: true,
            message: this.$t("User.follow_rule5"),
            trigger: "blur",
          },
        ],
        track_followuptype: [
          {
            required: true,
            message: "请选择下次跟进类型",
          },
        ],
        track_followuptime: [
          {
            required: true,
            message: "请选择下次跟进时间",
          },
        ],
      },
    };
  },
  components: {
    tipsTable,
    addTapPop,
  },
  created() {
    this.clientId = this.customerId;
    this.newclientTag = this.newclientTags;

    // 权限判断
    this.postbe_crmlevel = this.$store.state.POSTBE_CRMLEVEL;
    this.Userinfomation = this.$store.state.USER_INFO;

    // this.activeName = "first";
    this.bindRoot = false; //初始化
    this.getIntentionLevelList();
    if (this.isTrack) {
      this.activeName = "fourth";
      this.isRoottrack = true;
      this.getStudentTrackListApi();
      this.getCommodeData();
      this.getReceiverList();
      this.getObjectApi();
      this.getTraceNoteData();
    } else {
      this.isRoottrack = false;
      this.activeName = "first";
      // this.getclientOneData(this.customerId);
    }
    if (this.isHome) {
      this.activeName = "first";
      // this.getclientOneData(this.customerId);
      this.isRoottrack = false;
    }

    this.isClickBand = false;
    //获取数据
    this.getSourceData();
    this.getMarketer();
    this.getIntentCourseData();
    // this.getCommodeData();
    // this.getTraceNoteData();
    // this.getclientOneData(this.customerId);
    // this.getCrmStudentOneApi();
    this.className = this.ClassMessage.class_cnname;
    this.followForm.class_cnname = this.className;
    // this.followForm.audition_visittime=this.ClassMessage.hour_day;
    // this.getStudentTrackListApi();
    // this.getStudentInviteListApi(this.customerId);
    // this.getStudentAuditionListApi();
    // this.recordDatalen = this.recordData.length;
    // this.BindingInforlen = this.BindingInfor.length;
    // this.num = parseInt(this.UserInformation.client_intention_level);

    this.courseTypeRecruitApi();
    this.getTypeCourseCatApi();
    this.getAuditionTypesApi();
    this.getInviteGenreApi();
  },
  watch: {
    //用户信息监听
    ClassMessageinfo(n) {
      (() => {})(n, "32131232");
      this.ClassId = n.class_id;
      this.CourseId = n.course_id;
      this.HourId = n.hour_id;
      this.followForm.class_id = n.class_cnname;
      this.className = n.class_cnname;
      this.followForm.class_cnname = this.className;
      if (this.followForm.audition_genre == "1") {
        this.followForm.coursetype_branch = n.coursetype_id;
        this.filterCourseCat();
        this.followForm.coursecat_id = n.coursecat_id;
      } else {
        this.followForm.coursetype_branch = "";
        this.followForm.coursecat_id = "";
      } // this.followForm.audition_visittime = n.hour_day;
    },
    // id监听
    getcustomerId(n) {
      this.fllow_id = n;
      this.getclientOneData(n);
      this.getCommodeData();
      this.getReceiverList();
      this.getObjectApi();
      this.getTraceNoteData();
      this.getSourceData();
      this.getMarketer();
      this.getIntentCourseData();
    },
  },
  computed: {
    ClassMessageinfo() {
      return this.ClassMessage;
    },
    getcustomerId() {
      return this.customerId;
    },
    companyIsmajor() {
      return this.$store.state.companyIsmajor; //0是免费版 1是普通版   2是专业版
    },
  },
  methods: {
    getInviteGenreApi() {
      storeUser.getInviteGenreApi({}).then((res) => {
        const { code, data: _jb } = res.data;

        const data = _jb;
        if (code === 200) {
          this.inviteGenreList = data.list;
        } else {
          this.inviteGenreList = [];
        }
      });
    },
    getAuditionTypesApi() {
      storeUser.getAuditionTypesApi({}).then((res) => {
        (() => {})(res, "getAuditionTypesApi");
        const { code, data: _jb } = res.data;

        const data = _jb;
        if (code === 200) {
          this.auditionTypesList = data.list;
        } else {
          this.auditionTypesList = [];
        }
      });
    },
    handConfirm(val) {
      let labelList = [];
      val.forEach((item) => {
        labelList.push(item.label_name);
      });
      this.$http
        .addCrmStudentTagsAction({
          student_id: this.sId,
          label_list: JSON.stringify(labelList),
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.$emit("updateList");
            // this.getclientOneData(this.customerId);
            this.addTagVisable = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    courseTypeRecruitApi() {
      this.$http
        .courseTypeRecruitApi({
          coursetype_isrecruit: 1,
        })
        .then((res) => {
          (() => {})(res);
          const { code, data: _jb } = res.data;

          const data = _jb;
          if (code === 200) {
            this.courstTypeList = data.list;
          } else {
            this.courstTypeList = [];
          }
        });
    },
    filterCourseCat() {
      this.followForm.coursecat_id = "";
      this.getTypeCourseCatApi();
    },
    getTypeCourseCatApi() {
      this.$http
        .getTypeCourseCatApi({
          coursetype_id: this.followForm.coursetype_branch,
        })
        .then((res) => {
          const { code, data: _jb } = res.data;

          const data = _jb;
          if (code === 200) {
            this.courseCatList = data.list;
          } else {
            this.courseCatList = [];
          }
        });
    },

    // 课程列表
    getCrmStuCourseList() {
      storeUser
        .getCrmStuCourseList({
          student_id: this.sId,
          coursetype_id: this.campusCourseFliterData.coursetype_id,
          study_isreading: this.campusCourseFliterData.study_isreading,
          keyword: this.campusCourseFliterData.keyword,
        })
        .then((res) => {
          const { msg, data: _jb } = res.data;

          const data = _jb;
          const { courseList, field, coursetypeList } = data;
          this.campusCourseFliterData.campusCourseColumns =
            this.$Common.handleTable(field, this.ClasscolumnWidth, false, 0);
          this.campusCourseFliterData.coursetypeList = coursetypeList;
          this.campusCourseFliterData.campusCourseList = courseList;
          this.Classoptions.errortip = msg;
        });
    },
    // 班级列表
    getCrmStuClassApi() {
      storeUser
        .getCrmStuClassApi({
          student_id: this.sId,
          coursetype_id: this.campusClassFliterData.coursetype_id,
          coursecat_id: this.campusClassFliterData.coursecat_id,
          study_isreading: this.campusClassFliterData.study_isreading,
          keyword: this.campusClassFliterData.keyword,
        })
        .then((res) => {
          const { msg, data: _jb } = res.data;

          const data = _jb;
          const { classList, field, coursetypeList, coursecatList } = data;
          this.campusClassFliterData.campusClassColumns =
            this.$Common.handleTable(field, this.ClasscolumnWidth, false, 0);
          this.campusClassFliterData.coursetypeList = coursetypeList;
          this.campusClassFliterData.coursecatList = coursecatList;
          this.campusClassFliterData.campusClassList = classList;
          this.Classoptions.errortip = msg;
        });
    },
    resetMarkup() {
      this.stuInfoData.showAddMarkup = false;
      this.stuInfoData.markupList = [];
    },
    // 添加标签
    addMarkup() {
      this.stuInfoData.markupList.push({
        txt: this.stuInfoData.markup,
      });
      this.stuInfoData.markup = "";
    },
    // 移除标签
    removeMarkup(i) {
      this.stuInfoData.markupList.splice(i, 1);
    },
    //数据获取开始
    //获取招生渠道类型
    getSourceData() {
      storeUser.getSource({}).then((res) => {
        this.SchoolsourceOption = res.data.data.list;
        this.SchoolsourceOption.unshift({
          frommedia_id: "",
          frommedia_name: this.$t("Common.options"),
        });
      });
    },
    // 获取招生的负责人
    getMarketer() {
      storeUser.getMarketer({}).then((res) => {
        (() => {})(res.data.data.list);
        this.chiefPerson = res.data.data.list;
      });
    },
    //接待人->获取有接待权限的接待人
    getReceiverList() {
      storeUser.getReceiverList({}).then((res) => {
        (() => {})(res.data.data.list);
        this.ReceiverList = res.data.data.list;
      });
    },
    //获取意向课程
    getIntentCourseData() {
      storeUser.getIntentCourse({}).then((res) => {
        (() => {})(res.data);
        this.SchoolCourseOption = res.data.data.list;
      });
    },
    // 获取单个客户的基本信息
    getclientOneData(id) {
      (() => {})(this.isForm, 1111111);
      var fromValue;
      if (this.isForm) {
        fromValue = "1";
      } else {
        fromValue = "";
      }
      storeUser
        .getclientOne({
          client_id: id,
          from: fromValue,
        })
        .then((res) => {
          (() => {})(res.data.data.is_track);
          this.UserInformation = res.data.data.list;
          this.num = parseInt(this.UserInformation.client_intention_level);
          if (res.data.data.is_track == "1") {
            this.isyhavetrack = true;
            this.isyhavetrackedit = true;
            // this.activeName = "fourth";
            if (this.activeName == "first") {
              this.isRoottrack = false;
              this.isyhavetrackedit = false;
            }
          } else {
            this.isyhavetrack = false;
            this.isyhavetrackedit = false;
          }

          (() => {})(this.UserInformation);
        });
    },

    // 获取单个客户的跟踪记录
    getStudentTrackListApi() {
      storeUser
        .getStudentTrackListApi({
          student_id: this.sId,
        })
        .then((res) => {
          const { data } = res.data;
          var arr = [];
          data.list.forEach((item) => {
            var str = item.track_followmode_name;
            arr.push(
              Object.assign({}, item, {
                track_followcont: str,
                isClickReply: false,
                replay_note: "",
              })
            );
          });
          this.recordData = arr;
          this.recordDatalen = this.recordData.length;
          this.currentrecordData = arr.slice(0, 2);
        });
    },

    // 获取单个客户的绑定关系
    getFriendRelationData(id) {
      storeUser
        .getFriendRelation({
          client_id: id,
        })
        .then((res) => {
          (() => {})(res.data.data.list);
          this.FriendRelation = res.data.data.list;
        });
    },
    // 绑定学员->获取人员名称
    getClientNameData() {
      storeUser.getClientName({}).then((res) => {
        this.FriendName = res.data.data.list;
      });
    },
    // 获取单个客户的柜询记录-
    getStudentInviteListApi() {
      storeUser
        .getStudentInviteListApi({
          student_id: this.sId,
        })
        .then((res) => {
          this.tryRecordlist = res.data.data.list;
          var Columns = res.data.data.field;
          this.recordlistColumn = this.$Common.handleTable(
            Columns,
            this.recordcolumnWidth,
            false,
            0
          );
          if (res.data.code !== 200) {
            this.recordoptions.errortip = res.data.msg;
          }
        });
    },
    //获取单个客户的试听记录-
    getStudentAuditionListApi() {
      storeUser
        .getStudentAuditionListApi({
          student_id: this.sId,
        })
        .then((res) => {
          this.tryClasslist = res.data.data.list;
          var Columns = res.data.data.field;
          this.ClasslistColumn = this.$Common.handleTable(
            Columns,
            this.ClasscolumnWidth,
            false,
            0
          );
          if (res.data.code !== 200) {
            this.Classoptions.errortip = res.data.msg;
          }
        });
    },
    // 公共->意向星级注释列表->zjc
    getIntentionLevelList() {
      this.$http.getIntentionLevelList({}).then((res) => {
        let list = res.data.data.list;
        let arr = [];
        list.forEach((e) => {
          arr.push(e.intentlevel_remark);
        });
        this.intentionLevelList = arr;
      });
    },
    // 获取沟通类型
    getCommodeData() {
      storeUser.getCommode({}).then((res) => {
        this.CommodeData = res.data.data.list;
        (() => {})(res.data.data.list);
      });
    },
    // 获取沟通对象
    getObjectApi() {
      storeUser.getObjectApi({}).then((res) => {
        this.ObjectData = res.data.data.list;
        (() => {})(res.data.data.list);
      });
    },
    // 获取沟通模板
    getTraceNoteData() {
      storeUser.getTraceNote({}).then((res) => {
        this.TraceNoteData = res.data.data.list;
        (() => {})(res.data.data.list);
      });
    },
    //主管回复跟踪记录->ling
    levelReplayTrackAction(item, index) {
      storeUser
        .levelReplayTrackAction({
          track_id: this.oneTrackInfo.track_id,
          replay_note: this.oneTrackInfo.replay_note,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.recordData[index].isClickReply = false;
            this.currentrecordData = this.recordData.slice(0, 2);
            this.getStudentTrackListApi();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    //主管审阅点评记录->luijng
    levelReadTrackAction() {
      storeUser
        .levelReadTrackAction({
          track_id: this.oneTrackInfo.track_id,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getStudentTrackListApi();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    // 点击阅读
    handRead(item, index) {
      (() => {})(item, index);
      this.oneTrackInfo = item; //单个跟踪记录信息
      this.levelReadTrackAction(); //主管审阅点评记录->luijng
    },
    // 点击回复
    handReply(item, index) {
      (() => {})(item, index);
      this.oneTrackInfo = item; //单个跟踪记录信息
      this.recordData[index].isClickReply = true;
      this.currentrecordData = this.recordData.slice(0, 2);
    },
    // 关闭取消回复框
    handCloseReply(item, index) {
      (() => {})(item, index);
      this.recordData[index].isClickReply = false;
      this.recordData[index].replay_note = "";
      this.currentrecordData = this.recordData.slice(0, 2);
    },
    //数据获取结束
    hideUserSliderBox() {
      this.$emit("hideUserSliderBox");
    },
    onFllowSubmit(v) {
      (() => {})(this.fllow_id);
      this.$refs["followForm"].validate((valid) => {
        if (valid) {
          v.class_id = this.ClassId;
          v.course_id = this.CourseId;
          v.hour_id = this.HourId;
          // var value=v;
          // value.track_intention_level=333;
          // // (() => {})(this.clientLevelNum)
          // // (() => {})(value.track_intention_level)
          // (() => {})(value)
          // (() => {})(this.customerId)
          v.student_id = this.sId;
          this.$emit("onFllowSubmit", v);
        } else {
          return false;
        }
      });
    },
    // 绑定的学员跟进点击
    ClickFloow(v) {
      // 数据初始化
      this.followForm.client_id = "";
      this.followForm.track_linktype = "";
      this.followForm.track_validinc = "";
      this.followForm.track_intention_level = null;
      this.followForm.track_followuptype = "";
      this.followForm.track_followuptime = "";
      this.followForm.track_followmode = ""; //本次跟进模式0普通回访1柜询2试听3转正-1跟进无意向
      // track_note_temp = "" //沟通模板不需要传
      this.followForm.track_note = "";
      this.followForm.class_id = "";
      this.followForm.class_cnname = "";
      this.followForm.invite_genre = ""; //邀约柜询类型 邀约类型 变量 0普通柜询1能力测试
      this.followForm.client_lapsedtype = ""; //无意向类型 0已报异业1强烈抵触2其他
      this.followForm.object_code = ""; //沟通对象
      this.followForm.audition_genre = ""; //试听类型
      this.followForm.receiver_name = ""; //接待人

      this.className = "";
      this.ClassId = "";
      this.CourseId = "";
      this.bindRoot = true;
      this.activeName = "fourth";
      this.isRoottrack = true;
      this.isClickBand = true;
      (() => {})(v);
      this.$emit("ClickFloow", v);
    },
    studentBinding() {
      this.$emit("studentBinding");
    },
    Clickedit() {
      this.$emit("Clickedit");
    },
    leaning() {
      this.$emit("leaning");
    },
    // 选择试听类型
    ClickAudition() {
      this.className = "";
      this.followForm.class_id = "";
      this.followForm.class_cnname = "";
      this.followForm.coursetype_branch = "";
      this.followForm.coursecat_id = "";
      this.$emit("ClickAudition", this.followForm.audition_genre);
    },
    // 选择试听时间
    ClickAuditiontime() {
      this.className = "";
      this.followForm.class_id = "";
      this.followForm.class_cnname = "";
      this.$emit("ClickAuditiontime", this.followForm.audition_visittime);
    },
    //更多下拉
    handmoreVisible() {
      if (this.moreVisible == false) {
        this.moreVisible = true;
      } else {
        this.moreVisible = false;
      }
    },
    // 选择模板时
    handClickModel() {
      this.followForm.track_note = this.checkList;
    },
    handleSliderClick() {
      // (() => {})(this.isRoot,this.iscanEdit,this.tabEdit)
      if (this.activeName == "first") {
        // this.getclientOneData(this.customerId);
        this.tabEdit = true;
        this.isRoottrack = false;
      } else {
        if (this.activeName == "fourth") {
          this.followForm = {
            client_id: "",
            track_linktype: "",
            track_validinc: "",
            track_intention_level: null,
            track_followuptype: "",
            track_followuptime: "",
            track_followmode: "", //本次跟进模式0普通回访1柜询2试听3转正-1跟进无意向
            // track_note_temp: "", //沟通模板不需要传
            track_note: "",
            class_id: "",
            coursecat_id: "",
            class_cnname: "",
            invite_genre: "", //邀约柜询类型 邀约类型 变量 0普通柜询1能力测试
            client_lapsedtype: "", //无意向类型 0已报异业1强烈抵触2其他
            object_code: "", //沟通对象
            audition_genre: "", //试听类型
            receiver_name: "", //接待人
          };
          this.isRoottrack = true;
          this.isyhavetrackedit = true;
          this.getCommodeData();
          this.getReceiverList();
          this.getObjectApi();
          this.getTraceNoteData();
        } else {
          this.isRoottrack = false;
        }
        this.tabEdit = false;
        this.isyhavetrackedit = false;
      }
      if (this.activeName == "second") {
        this.getStudentTrackListApi();
      } else if (this.activeName == "zero") {
        this.getCrmStuCourseList();
      } else if (this.activeName == "third") {
        this.getStudentInviteListApi();
        this.getStudentAuditionListApi();
        // this.getclientOneAuditionData(this.customerId);
      } else if (this.activeName == "autition") {
        this.getStudentAuditionListApi();
        // this.getclientOneAuditionData(this.customerId);
      } else if (this.activeName == "five") {
        this.getCrmStuClassApi();
      }
      this.$emit("handleSliderClick", this.activeName);
    },
    // 关闭更多
    closeMore(event) {
      var btn = document.querySelector(".btn-binding");
      if (btn) {
        if (!btn.contains(event.target)) {
          //按钮.app-download以外的区域
          this.moreVisible = false;
        }
      }
    },
    sourceFilter() {
      // 数据初始化
      this.followForm.track_followuptype = "";
      this.followForm.track_followuptime = "";
      this.followForm.track_note = "";
      this.followForm.class_id = "";
      this.followForm.receiver_name = "";
      this.followForm.class_cnname = "";
      this.checkList = "";
      this.className = "";
      this.ClassId = "";
      this.CourseId = "";
      // this.followForm.audition_visittime="";
    },
  },
};
</script>
<style lang="less">
.school-user-seeing {
  .tag-list {
    padding: 10px 10px 0 40px !important;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
    height: 40px;

    .tagItem {
      text-align: center;
      display: block;
      min-width: 80px;
      height: 28px;
      line-height: 28px;
      border-radius: 15px;
      color: #28abd9;
      font-size: 14px;
      padding: 0 18px;
      border: 1px solid #28abd9;
      margin-right: 20px;
      margin-bottom: 10px;
    }

    .addTagBtn {
      color: #28abd9;
      cursor: pointer;
      line-height: 38px;
    }
  }

  .slider-top-see .myinfo {
    .el-info-row {
      margin-right: 25px !important;
    }
    .el-col label {
      width: 110px !important;
    }

    .user-infor {
      display: flex;
      align-items: center;
      padding: 10px 50px 0 45px;
      font-size: 16px;
    }
  }

  .slider-cont {
    padding-top: 20px;
  }

  // 意向星级样式
  .el-rate {
    height: 20px;
    line-height: 20px;

    i {
      line-height: 20px;
    }
  }
  .btn-biding-disable {
    background: #ddd;
    border-color: #ddd;
  }
  .btn-biding-disable:hover,
  .btn-biding-disable:focus {
    background: #ddd;
    border-color: #ddd;
  }
  .BaseInfo {
    padding-left: 20px;

    .form-info-cont {
      label {
        margin-right: 10px;
        text-align: right;
      }
    }
  }

  .silder-contain .slider-cont .BaseInfo .form-info-cont label {
    width: 100px !important;
  }
  .silder-contain .slider-cont .BaseInfo .form-info-cont {
    display: flex;
    align-items: center;
    // 推荐人信息
    .recommend-info {
      display: flex;
      align-items: center;
      span {
        display: inline-block;
        width: 1px;
        height: 20px;
        margin: 0 10px;
        background: rgba(223, 223, 223, 1);
      }
    }
  }
  .silder-contain .el-tabs__nav {
    padding: 10px 0px 0px 0px;
  }
  .el-row .grid-content-img img {
    height: 100%;
  }
  .slider-studentBind .el-row .el-col {
    min-height: 178px;
  }
  .el-row .grid-content > p {
    height: auto;
  }
  .el-row .grid-content .communite-cont {
    line-height: 28px;
    display: flex;
    justify-content: space-between;
    p {
      flex: 1;
    }
    .btns {
      width: 135px;
      margin-left: 10px;
      .el-button {
        width: 60px;
      }
      .btn-disabled {
        background-color: #cccccc;
        border-color: #cccccc;
      }
    }
  }
  .el-row .grid-content .communite-replay {
    display: flex;
    border-top: 1px dashed #ddd;
    .replay-cont {
      flex: 1;
      line-height: 24px;
    }
    .img {
      width: 40px;
      height: 40px;
      overflow: hidden;
      border-radius: 50%;
      margin-right: 10px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .replay-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .el-row {
    padding: 12px 20px;
  }
  .track-record {
    padding-left: 30px;
    margin-bottom: 15px;
    position: relative;
    &::before {
      content: "";
      top: 0;
      left: 0;
      width: 8px;
      height: 8px;
      padding: 1px;
      position: absolute;
      border-radius: 50%;
      border: 2px solid #28abd9;
      background-clip: content-box;
      background-color: #28abd9;
    }
    &::after {
      content: "";
      top: 12px;
      left: 6px;
      width: 2px;
      height: calc(100% + 5px);
      background-color: #28abd9;
      position: absolute;
    }
    .track-time {
      margin-bottom: 12px;
      color: #a4a4a4;
      font-size: 12px;
    }
    .track-racord__content {
      box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.08);
    }
  }
  .myinfo-summary {
    display: flex;
    margin-top: 10px;
    align-items: center;
    background-clip: content-box;
    background-color: #f1f4fa;
    span {
      flex: 1;
      line-height: 50px;
      text-align: center;
      color: #95a5b9;
      font-size: 16px;
      position: relative;
      &::after {
        content: "";
        position: absolute;
        right: 0;
        top: 8px;
        height: calc(100% - 16px);
        width: 1px;
        background-color: #ddd;
      }
      &:last-child {
        &::after {
          display: none;
        }
      }
    }
    em {
      color: #25a4d1;
      font-style: normal;
    }
  }
  .slider-top-see {
    .slider-person-info {
      border-bottom: none !important;
    }
  }
  .markup-container {
    padding: 20px 10px 0 30px;
    .markup-add {
      .markup-header {
        display: flex;
        margin-bottom: 10px;
        align-items: center;
        justify-content: space-between;
        p {
          color: #3a3a3a;
          font-size: 14px;
          span {
            color: #adadad;
          }
        }
      }
      .markup-content {
        display: flex;
        align-items: center;
      }

      .markup-add__content {
        display: flex;
        margin-top: 10px;
        flex-wrap: wrap;
        .markup-content__row {
          padding: 0 12px;
          margin: 6px 15px 6px 0;
          line-height: 30px;
          border-radius: 15px;
          color: #20a8d8;
          border: 1px solid #20a8d8;
          position: relative;
          .el-icon-error {
            top: -5px;
            right: -4px;
            position: absolute;
            cursor: pointer;
            color: red;
            z-index: 1;
          }
        }
      }
    }
  }
}
</style>
